import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { Button, Typography } from '@material-ui/core'
import { ReactComponent as TriangleExclaimationIcon } from 'assets/icons/triangle-exclaimation-icon.svg'
import { ROUTES } from 'routes'
import { LayoutDialog } from 'shared'

import { useStyles } from './InfoMessageDialog.style'

const InfoMessageDialog = ({ onClose, ...dialogProps }) => {
  const classes = useStyles()
  const { slugUrlOrId } = useParams()

  return (
    <LayoutDialog
      {...dialogProps}
      onClose={onClose}
      contentClassName={classes.contentDialog}
      className={classes.dialog}>
      <div className={classes.initialMessageContainer}>
        <div className={classes.alertContainer}>
          <TriangleExclaimationIcon />
          <div className={classes.messageContainer}>
            <Typography className={classes.alertParagraph}>
              Podrás ver y descargar el listado de inscriptos pero no editarlo, puesto que el evento
              se encuentra suspendido.
            </Typography>
            <Typography color='primary' className={classes.text}>
              Si necesitas ayuda puedes completar el formulario para tal fin haciendo click{' '}
              <Link to={`${ROUTES.EVENTS.NEED_HELP}/${slugUrlOrId}`} color='primary'>
                aquí.
              </Link>
            </Typography>
          </div>
        </div>
      </div>
      <Button variant='contained' color='primary' className={classes.button} onClick={onClose}>
        Aceptar
      </Button>
    </LayoutDialog>
  )
}

export default InfoMessageDialog
